// Small utility to consistently compute an employee display name
export function getEmployeeFullName(emp) {
  if (!emp) return '';
  const fromProp = emp.fullName;
  const p = emp.person;
  const fn = p?.firstName ?? emp.firstName ?? '';
  const ln = p?.lastName ?? emp.lastName ?? '';
  const composed = `${fn} ${ln}`.trim();
  return (fromProp && fromProp.trim().length > 0) ? fromProp : (composed || '');
}

export function getInitialsFromEmployee(emp) {
  if (!emp) return '';
  const p = emp.person;
  const fn = (p?.firstName ?? emp.firstName ?? '').trim();
  const ln = (p?.lastName ?? emp.lastName ?? '').trim();
  return `${fn.charAt(0) || ''}${ln.charAt(0) || ''}`.toUpperCase();
}

